import realMachinesLogo from '@/assets/branding/real-maquinas-logo-transparent.png'

interface LoadingScreenProps {
  message?: string
}

export function LoadingScreen({ message = 'Carregando…' }: LoadingScreenProps) {
  return (
    <div className="loading-screen" role="status" aria-live="polite">
      <img
        className="loading-screen__logo"
        src={realMachinesLogo}
        alt="Real Máquinas — Mecânica especializada em máquinas pesadas"
        width="1636"
        height="1252"
      />
      <span className="loading-screen__spinner" aria-hidden="true" />
      <span>{message}</span>
    </div>
  )
}
